$(document).ready(function(){
  function initLogoList(el) {
    var $el = $(el);
    if ($el.data('perf-flickity-init')) return;
    $el.data('perf-flickity-init', true);
    $el.flickity({
      cellAlign: 'left',
      contain: true,
      autoPlay: 1500,
      wrapAround: true
    });
  }

  var logoLists = document.querySelectorAll('.logo-list__wrapper');
  if ('IntersectionObserver' in window) {
    var logoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          initLogoList(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '600px 0px' });
    logoLists.forEach(function(el) { logoObserver.observe(el); });
  } else {
    logoLists.forEach(function(el) { initLogoList(el); });
  }

  $('.sidebar-block__heading').click(function(){
      $(this).parents('.sidebar-toggle-option').siblings('.sidebar-block__content').slideToggle();
      $(this).parents('.sidebar-toggle-option').toggleClass('active');
  })
  $('.swatch__option').click(function(){
    var tabId = $(this).data('tab-id');
    //console.log(tabId);
    $('.spec-weight').removeClass('active');
    $('#tab-'+ tabId).addClass('active');
  })

  if ( matchMedia('screen and (max-width: 798px)').matches ) {
    $('.product-gallery__main-wrap').flickity({
      cellAlign: 'left',
      contain: true,
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true
    });
  }
  $('.product-accordion').click(function(){
      $(this).toggleClass('active');
  })
}) 